module.exports = __webpack_public_path__ + "img/save_invoice_disabled.9dd1d852.svg";